export default "Jeg er ikke sikker på, hvad historien bag dette rum er - måske er det en del af mysteriet?\n";